module.exports = __webpack_public_path__ + "img/JO.a88b971b.svg";